/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
import type { FundCentreVerificationResponse } from "../models/FundCentreVerificationResponse";
import type { SalesforceVerificationResponse } from "../models/SalesforceVerificationResponse";

export class VerificationService {
    /**
     * Verify Fund Centre user
     * This will verify a Fund Centre user and generate a token. Needs to be called twice for DAT regions.
     * @param userId The unique user id which can be found in subject claim of the JWT.
     * @param inviteId The invite id will come from the email and expire after certain amount of time.
     * @returns FundCentreVerificationResponse User verified and session token returned
     * @throws ApiError
     */
    public static verifyFundCentreUser(
        userId: any,
        inviteId: any,
    ): CancelablePromise<FundCentreVerificationResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/users/{userId}/verify/{inviteId}",
            path: {
                userId: userId,
                inviteId: inviteId,
            },
            errors: {
                404: `User not found or invalid/expired invite`,
                500: `Service failure`,
            },
        });
    }
    /**
     * Verify Salesforce user
     * This will verify a Salesforce Retail user and generate a token for a particular client.
     * @param userId The unique user id which can be found in Pardot profile.
     * @returns SalesforceVerificationResponse Successful operation
     * @throws ApiError
     */
    public static verifySalesforceRetailUser(
        userId: any,
    ): CancelablePromise<SalesforceVerificationResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/users/{userId}/retail/verify",
            path: {
                userId: userId,
            },
            errors: {
                404: `User not found`,
                500: `Service failure`,
            },
        });
    }
    /**
     * Verify Salesforce user
     * This will verify a Salesforce DC user and generate a token for a particular client.
     * @param userId The unique user id which can be found in Pardot profile.
     * @returns SalesforceVerificationResponse Successful operation
     * @throws ApiError
     */
    public static verifySalesforceDcUser(
        userId: any,
    ): CancelablePromise<SalesforceVerificationResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/users/{userId}/dc/verify",
            path: {
                userId: userId,
            },
            errors: {
                404: `User not found`,
                500: `Service failure`,
            },
        });
    }
    /**
     * Verify Salesforce user
     * This will verify a Salesforce Institutional user and generate a token for a particular client.
     * @param userId The unique user id which can be found in Pardot profile.
     * @returns SalesforceVerificationResponse Successful operation
     * @throws ApiError
     */
    public static verifySalesforceInstitutionalUser(
        userId: any,
    ): CancelablePromise<SalesforceVerificationResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/users/{userId}/institutional/verify",
            path: {
                userId: userId,
            },
            errors: {
                404: `User not found`,
                500: `Service failure`,
            },
        });
    }
}
